import React from 'react';
import { CheckCircle, FileCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const StudentVisaGuidance: React.FC = () => {
    const navigate = useNavigate();

    const handleContactClick = () => {
        navigate('/eligibility?service=immigration');
    };

    return (
        <div className="bg-white min-h-screen pt-32 pb-20">
            <div className="bg-[#009B8F] text-white py-16 mb-16">
                <div className="max-w-7xl mx-auto px-6">
                    <h1 className="text-4xl md:text-5xl font-serif mb-4">Student Visa Guidance</h1>
                    <p className="text-xl text-white/90 max-w-2xl">
                        Complete documentation advice, legal rules, and compliance support from the start.
                    </p>
                </div>
            </div>

            <div className="max-w-5xl mx-auto px-6">
                <div className="flex items-center gap-4 mb-8">
                    <div className="p-3 bg-[#009B8F]/10 rounded-full">
                        <FileCheck className="text-[#009B8F] w-8 h-8" />
                    </div>
                    <h2 className="text-3xl font-serif text-[#011E26]">Be Fully Prepared Before You Apply</h2>
                </div>

                <div className="prose prose-lg text-slate-600 max-w-none">
                    <p className="mb-4">
                        At NexOverseas, our Student Visa Guidance service is designed to provide students with complete documentation advice, legal rules, and compliance support right from the start, even before they begin their visa application process with us. The goal is to help students be fully prepared, well-informed, and confident as they take their first steps toward studying abroad.
                    </p>
                    <p className="mb-4">
                        We focus on ensuring that students understand the entire framework of visa requirements, including eligibility criteria, necessary documentation, and compliance with immigration rules. This early guidance helps students avoid common mistakes, delays, or application rejections, giving them a strong foundation before engaging with universities or legal professionals.
                    </p>

                    <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#009B8F] mb-8">
                        <h3 className="text-lg font-bold text-[#011E26] mb-3 uppercase tracking-wide">Through our guidance, students will:</h3>
                        <ul className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            {[
                                "Receive clear instructions on documentation requirements and proper formats",
                                "Understand the legal rules and compliance expectations specific to their study destination",
                                "Learn how to structure their applications effectively for maximum efficiency",
                                "Gain insights on preparing for timelines and deadlines, ensuring a smooth start to the application process"
                            ].map((item, i) => (
                                <li key={i} className="flex items-start gap-2 text-sm font-medium">
                                    <CheckCircle className="w-5 h-5 text-[#009B8F] flex-shrink-0" />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <p className="mb-4">
                        This service is suitable for students applying to universities across all countries, providing universal support that prepares them for the specific requirements of their chosen destinations. By receiving guidance early, students gain clarity, confidence, and peace of mind, making the entire visa process more organised, stress-free, and efficient.
                    </p>

                    <p className="mb-6 font-medium text-[#011E26]">
                        With Student Visa Guidance, NexOverseas ensures that students are not just submitting forms, they are building a strong, compliant application strategy that sets the stage for a successful academic journey abroad.
                    </p>

                    <button
                        onClick={handleContactClick}
                        className="bg-[#009B8F] text-white px-8 py-3 font-bold uppercase tracking-widest hover:bg-[#00857a] transition-colors rounded-sm shadow-lg"
                    >
                        Get in Touch Today
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StudentVisaGuidance;
